    
    let tabnamecontent = document.querySelectorAll(".tab-name-content");

      tabnamecontent.forEach(tabnamecontent => {
        tabnamecontent.addEventListener("click", event => {

          const active = document.querySelector(".tab-name-content.active");

          if (active && active !== tabnamecontent) {
            active.classList.toggle("active");
            active.nextElementSibling.style.maxHeight = 0;
          }

          tabnamecontent.classList.toggle("active");

          const tabContentAns = tabnamecontent.nextElementSibling;

          if (tabnamecontent.classList.contains("active")) {
            tabContentAns.style.maxHeight = tabContentAns.scrollHeight + "px";
          } else {
            tabContentAns.style.maxHeight = 0;
          }

        });
    });
    
    
    
    const myDiv = document.getElementById('myDiv');
    const targetElement = document.getElementById('targetElement');
    let lastScroll = window.pageYOffset;
    let timeout;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
    
      // check if target element has been scrolled past
      const targetRect = targetElement.getBoundingClientRect();
      if (targetRect.bottom <= 0) {
        myDiv.style.display = 'block'; // show sticky bar
        if (currentScroll > lastScroll) { // scrolling down
          myDiv.style.bottom = '-1px';
        } else { // scrolling up
          myDiv.style.bottom = '-175px';
        }
    
        lastScroll = currentScroll;
    
       
      } else {
        myDiv.style.display = 'none'; // hide sticky bar
      }
    });